import React from 'react';

type BookmarkIconProps = React.SVGProps<SVGSVGElement>;

export const BookmarkIcon: React.FC<BookmarkIconProps> = (props) => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <path
      d="M12.5016 15.835L6.66829 11.6683L0.834961 15.835V2.50163C0.834961 2.0596 1.01056 1.63568 1.32312 1.32312C1.63568 1.01056 2.0596 0.834961 2.50163 0.834961H10.835C11.277 0.834961 11.7009 1.01056 12.0135 1.32312C12.326 1.63568 12.5016 2.0596 12.5016 2.50163V15.835Z"
      stroke="#053F3A"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BookmarkIcon.displayName = 'BookmarkIcon';

export default BookmarkIcon;
